import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ServiceCategory from "../ChairLift/ServiceCategory";

const SightRoutes  = () => {
  return (
    <div className="col-12">
      <ServiceCategory serviceId={6} />
    </div>
  );
};
export default SightRoutes 
